




















































































import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetShiftList, InsertShift, UpdateShiftById, DeleteShift} from '../../../api/specialDictionary'
import {GetPinYin, GetWuBi} from '../../../api/sys'
import {GetListByCode} from "@/api/configureDictionary"

@Component
export default class Country extends AbpBase {
	cancel(){
		this.dialogFormVisible = false
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.dialogFormVisible = false;
			(this.$refs.form as any).resetFields()
			this.getData()
		}
	}
	columns = [
		{
			key: 'shiftName',
			title: '班次名称'
		},
		{
			key: 'stdate',
			title: '开始时间'
		},
		{
			key: 'eddate',
			title: '结束时间'
		},
		// {
		// 	key: 'ranStdate',
		// 	title: '随机开始时间'
		// },
		// {
		// 	key: 'ranEddate',
		// 	title: '随机结束时间'
		// },
		{
			key: 'status',
			title: '是否启用',
			render:(h:any, p:any)=>{
				return h('span', p.row.status ? '启用' : '禁用')
			}
		},
		{
			key: 'spare',
			title: '备注'
		},
		{
			key: '',
			width: 190,
			title: '操作',
			render:(h:any, p:any)=>{
				return h('div', [
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
					h('Button',{
						props:{type: 'error'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),
				])
			}
		},
	]
	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm: any = {}
	dialogFormVisible = false
	dialogFormLabelWidth = '110px'
	tableTotalSize = 0
	tableData = []
	tableLoading = false
	wardSxs = [] // 班次下拉
	center = "center"
	created() {
		this.getData()
		this.getSelects()
	}

	//获取拼音五笔
	async getCode(val: any) {
		let query = {inputStr: val}
		let res1 = await GetPinYin(query)
		let res2 = await GetWuBi(query)
		this.dialogForm.shiftPY = res1
		this.dialogForm.shiftWB = res2
	}

	async getSelects(){
		let res = await GetListByCode({input:'024'})
		this.wardSxs = res
	}

	createCounty() {
		this.dialogTitle = '新增班次'
		this.dialogForm = {status: true, shiftPY: '', shiftWB: ''}
		this.dialogFormVisible = true
	}

	private async getData() {
		this.tableLoading = true
		let res = await GetShiftList({
			QueryString: this.key,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}

	handleClose() {
		this.dialogFormVisible = false
	}

	edit(row: any) {
		this.dialogTitle = '编辑班次'
		this.dialogForm = JSON.parse(JSON.stringify(row))
		this.dialogFormVisible = true
	}

	async del(row: any) {
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteShift({Id: row.id})
			this.getData()
		}).catch(() => {

		});
	}

	async confirm() {
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				if (this.dialogTitle === '新增班次') {
					let res = await InsertShift(this.dialogForm)
				} else if (this.dialogTitle === '编辑班次') {
					let res = await UpdateShiftById(this.dialogForm)
				}
				this.dialogFormVisible = false
				this.getData()
			}
		})
	}

	rules = {
		shiftName: [{required: true, message: '请输入内容', trigger: 'blur'}],
		shiftPY: [{required: true, message: '请输入内容', trigger: 'blur'}],
		shiftWB: [{required: true, message: '请输入内容', trigger: 'blur'}],
		stdate: [{required: true, message: '请输入内容', trigger: 'blur'}],
		eddate: [{required: true, message: '请输入内容', trigger: 'blur'}],
		ranStdate: [{required: true, message: '请输入内容', trigger: 'blur'}],
		ranEddate: [{required: true, message: '请输入内容', trigger: 'blur'}],
	}

	pageChange(val: any) {
		this.page = val
		this.getData()
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/shift/index.vue